import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FEED } from "./RoutesUrl";
import { getStoredUserTargetRoute } from "../utils/authRoutingUtils";

const LoggedInRoute = (props) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkUser = () => {
    const signupData = JSON.parse(localStorage.getItem("SignupData") || "{}");
    if (signupData?.data?.id || signupData?.data?.token) {
      setIsLoggedIn(false);
      const target = getStoredUserTargetRoute() || FEED || "/feed";
      return navigate(target, { replace: true });
    }
    setIsLoggedIn(true);
  };

  useEffect(() => {
    checkUser();
  }, []);

  return <>{isLoggedIn ? props.children : null}</>;
};

export default LoggedInRoute;
